var map = {
	"./file-img-bmp.jpg": "787a",
	"./file-img-doc.jpg": "2375",
	"./file-img-docx.jpg": "8a20",
	"./file-img-gif.jpg": "144a",
	"./file-img-jpg.jpg": "2bf7",
	"./file-img-other.jpg": "30ad",
	"./file-img-pdf.jpg": "2589",
	"./file-img-png.jpg": "5366",
	"./file-img-ppt.jpg": "030c",
	"./file-img-pptx.jpg": "7b5b",
	"./file-img-xls.jpg": "30b2",
	"./file-img-xlsx.jpg": "8a04",
	"./file-img-zip.jpg": "39e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "659a";